import ListingSlider from './listing-slider';
export default ListingSlider;